module.exports = __webpack_public_path__ + "static/img/bg-9.051f334.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-9.png
// module id = Pvff
// module chunks = 0